import React from 'react';
import { ArrowRight, CheckCircle, CheckCheck, CreditCard, QrCode, Camera, FileText, Edit3, MoreHorizontal, History } from 'lucide-react';
import { Apple, Smartphone } from 'lucide-react';
import { useHistory } from 'react-router-dom';
import { APP_STORE_URL, PLAY_STORE_URL } from '../../utils/constants';
import * as S from './styles';

// WhatsApp Phone Mockup Component
const WhatsAppMockup = () => (
    <S.PhoneMockup>
        <S.WhatsAppScreen>
            <S.WhatsAppHeader>
                <S.WhatsAppAvatar>S</S.WhatsAppAvatar>
                <S.WhatsAppContactName>Mi Negocio</S.WhatsAppContactName>
            </S.WhatsAppHeader>
            <S.WhatsAppMessages>
                <S.WhatsAppBubble>
                    Hola! Te recordamos tu cita manana Miercoles 15 de Enero a las 15:00hs.
                    <br /><br />
                    Responde SI para confirmar.
                    <S.WhatsAppTime>
                        14:32 <CheckCheck size={14} />
                    </S.WhatsAppTime>
                </S.WhatsAppBubble>
                <S.WhatsAppBubbleIncoming>
                    SI, confirmo!
                    <S.WhatsAppTime>14:35</S.WhatsAppTime>
                </S.WhatsAppBubbleIncoming>
                <S.WhatsAppBubble>
                    Perfecto! Tu cita esta confirmada. Te esperamos manana.
                    <S.WhatsAppTime>
                        14:35 <CheckCheck size={14} />
                    </S.WhatsAppTime>
                </S.WhatsAppBubble>
            </S.WhatsAppMessages>
        </S.WhatsAppScreen>
    </S.PhoneMockup>
);

// Mercado Pago Payment Mockup Component
const PaymentMockup = () => (
    <S.PaymentCard>
        <S.PaymentHeader>Mercado Pago</S.PaymentHeader>
        <S.PaymentBody>
            <S.PaymentAmount>$2,500</S.PaymentAmount>
            <S.PaymentSuccess>
                <CheckCircle size={48} />
                Pago recibido
            </S.PaymentSuccess>
            <S.PaymentDetails>
                <S.PaymentDetailRow>
                    <span>Cliente</span>
                    <span>Maria Garcia</span>
                </S.PaymentDetailRow>
                <S.PaymentDetailRow>
                    <span>Servicio</span>
                    <span>Consulta + Servicio</span>
                </S.PaymentDetailRow>
                <S.PaymentDetailRow>
                    <span>Fecha</span>
                    <span>15 Ene, 15:00</span>
                </S.PaymentDetailRow>
            </S.PaymentDetails>
        </S.PaymentBody>
    </S.PaymentCard>
);

// Client Details Mockup Component
const ClientDetailsMockup = () => (
    <S.ClientDetailCard>
        <S.ClientPhoto>
            <Camera size={48} />
            <S.ClientPhotoOverlay>
                <S.ClientPhotoDate>Mayo 12</S.ClientPhotoDate>
                <S.ClientPhotoCarousel>
                    <S.CarouselDot $active />
                    <S.CarouselDot />
                    <S.CarouselDot />
                </S.ClientPhotoCarousel>
            </S.ClientPhotoOverlay>
        </S.ClientPhoto>
        <S.ClientInfoSection>
            <S.ClientName>DORIS LEE</S.ClientName>
            <S.FormulaSection>
                <S.FormulaIcon>
                    <FileText />
                </S.FormulaIcon>
                <S.FormulaText>FORMULA</S.FormulaText>
            </S.FormulaSection>
            <S.ClientActionRow>
                <S.ClientActionButton>
                    <Edit3 />
                </S.ClientActionButton>
                <S.ClientActionButton>
                    <MoreHorizontal />
                </S.ClientActionButton>
            </S.ClientActionRow>
        </S.ClientInfoSection>
    </S.ClientDetailCard>
);

const BusinessCTAPresenter: React.FC = () => {
    const history = useHistory();

    return (
        <>
       

            {/* WhatsApp Reminders Section */}
            <S.FeatureSection bgColor="#E8F5E9">
                <S.FeatureContent>
                    <S.FeatureRowReversed>
                        <S.FeatureVisualColumn>
                            <WhatsAppMockup />
                        </S.FeatureVisualColumn>
                        <S.FeatureTextColumn>
                            <S.FeatureHeading>
                                Recordatorios automaticos por WhatsApp
                            </S.FeatureHeading>
                            <S.FeatureDescription>
                                Reduce las inasistencias hasta un 40%. Tus clientes reciben
                                recordatorios automaticos antes de cada cita y pueden confirmar
                                con un simple mensaje.
                            </S.FeatureDescription>
                            <S.FeatureList>
                                <S.FeatureListItem iconColor="#25D366">
                                    <CheckCircle size={20} /> Recordatorios 24 horas antes
                                </S.FeatureListItem>
                                <S.FeatureListItem iconColor="#25D366">
                                    <CheckCircle size={20} /> Confirmacion de cita automatica
                                </S.FeatureListItem>
                                <S.FeatureListItem iconColor="#25D366">
                                    <CheckCircle size={20} /> Notificacion de cambios al instante
                                </S.FeatureListItem>
                            </S.FeatureList>
                        </S.FeatureTextColumn>
                    </S.FeatureRowReversed>
                </S.FeatureContent>
            </S.FeatureSection>

            

            {/* Mercado Pago Integration Section */}
            <S.FeatureSection bgColor="#E3F2FD">
                <S.FeatureContent>
                    <S.FeatureRow>
                        <S.FeatureTextColumn>
                            <S.FeatureHeading>
                                Cobros con Mercado Pago integrado
                            </S.FeatureHeading>
                            <S.FeatureDescription>
                                Acepta pagos de forma simple y segura. Tarjetas de credito,
                                debito, QR o links de pago. Todo integrado en tu agenda sin
                                complicaciones.
                            </S.FeatureDescription>
                            <S.FeatureList>
                                <S.FeatureListItem iconColor="#009EE3">
                                    <CreditCard size={20} /> Pago con tarjeta de credito y debito
                                </S.FeatureListItem>
                                <S.FeatureListItem iconColor="#009EE3">
                                    <QrCode size={20} /> Codigo QR en tu local
                                </S.FeatureListItem>
                                <S.FeatureListItem iconColor="#009EE3">
                                    <CheckCircle size={20} /> Links de pago por WhatsApp
                                </S.FeatureListItem>
                            </S.FeatureList>
                        </S.FeatureTextColumn>
                        <S.FeatureVisualColumn>
                            <PaymentMockup />
                        </S.FeatureVisualColumn>
                    </S.FeatureRow>
                </S.FeatureContent>
            </S.FeatureSection>

            {/* Client Details Section */}
            <S.FeatureSection bgColor="#FDF2F8">
                <S.FeatureContent>
                    <S.FeatureRowReversed>
                        <S.FeatureVisualColumn>
                            <ClientDetailsMockup />
                        </S.FeatureVisualColumn>
                        <S.FeatureTextColumn>
                            <S.FeatureHeading>
                                Historial completo de tus clientes
                            </S.FeatureHeading>
                            <S.FeatureDescription>
                                Guarda fotos del trabajo realizado, notas y formulas. Todo el
                                historial de cada cliente en un solo lugar para ofrecer un
                                servicio personalizado.
                            </S.FeatureDescription>
                            <S.FeatureList>
                                <S.FeatureListItem iconColor="#ec4899">
                                    <Camera size={20} /> Fotos de cada visita
                                </S.FeatureListItem>
                                <S.FeatureListItem iconColor="#ec4899">
                                    <FileText size={20} /> Notas y formulas personalizadas
                                </S.FeatureListItem>
                                <S.FeatureListItem iconColor="#ec4899">
                                    <History size={20} /> Historial completo de servicios
                                </S.FeatureListItem>
                            </S.FeatureList>
                        </S.FeatureTextColumn>
                    </S.FeatureRowReversed>
                </S.FeatureContent>
            </S.FeatureSection>

                 {/* Original Hero Section */}
            <S.Container>
                <S.GradientBlob />

                <S.Content>
                    <S.Row>
                        <S.TextColumn>
                            <S.Heading>
                                Mora para tu negocio
                            </S.Heading>
                            <S.Description>
                                Potencia tu negocio con la plataforma de reservas líder para profesionales de servicios.
                                Software de gestión #1 según profesionales independientes.
                            </S.Description>
                            <S.Button onClick={() => history.push('/businessRegistration')}>
                                Descubre mas
                                <ArrowRight size={20} style={{ marginLeft: '0.5rem' }} />
                            </S.Button>

                            <S.StoreBadges>
                                <S.StoreBadge href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
                                    <Apple size={20} />
                                    <S.StoreBadgeText>
                                        <S.StoreBadgeSmall>Descargar en</S.StoreBadgeSmall>
                                        <S.StoreBadgeLarge>App Store</S.StoreBadgeLarge>
                                    </S.StoreBadgeText>
                                </S.StoreBadge>

                                <S.StoreBadge href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
                                    <Smartphone size={20} />
                                    <S.StoreBadgeText>
                                        <S.StoreBadgeSmall>Disponible en</S.StoreBadgeSmall>
                                        <S.StoreBadgeLarge>Google Play</S.StoreBadgeLarge>
                                    </S.StoreBadgeText>
                                </S.StoreBadge>
                            </S.StoreBadges>
                        </S.TextColumn>

                        <S.DashboardColumn>
                            <S.DashboardCard>
                                <S.DashboardInner>
                                    <S.Header>
                                        <S.HeaderPulse />
                                        <S.HeaderButtons>
                                            <S.HeaderButton />
                                            <S.HeaderButton />
                                        </S.HeaderButtons>
                                    </S.Header>
                                    <S.DashboardGrid>
                                        <S.StaffCard color="blue">
                                            <S.StaffImage src="https://picsum.photos/100/100?random=50" alt="Staff" />
                                            <S.StaffBar color="blue" width="5rem" />
                                            <S.StaffBar color="blue" width="3rem" />
                                        </S.StaffCard>
                                        <S.StaffCard color="pink">
                                            <S.StaffImage src="https://picsum.photos/100/100?random=51" alt="Staff" />
                                            <S.StaffBar color="pink" width="5rem" />
                                            <S.StaffBar color="pink" width="3rem" />
                                        </S.StaffCard>
                                        <S.StaffCard color="gray">
                                            <S.StaffImage src="https://picsum.photos/100/100?random=52" alt="Staff" />
                                        </S.StaffCard>
                                    </S.DashboardGrid>
                                </S.DashboardInner>
                            </S.DashboardCard>
                        </S.DashboardColumn>
                    </S.Row>
                </S.Content>
            </S.Container>
        </>
    );
};

export default BusinessCTAPresenter;
